/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  color?: string;
  padding?: '--cds-spacing-50' | '--cds-spacing-100';
};

const styles = {
  dot: (color?: string, padding = '--cds-spacing-100') => css`
    padding: 0 var(${padding});
    color: ${color ?? 'inherit'};
  `,
};

const DottedSeparator = ({ color, padding }: Props) => {
  return (
    <span aria-hidden css={styles.dot(color, padding)}>
      &#x2022;
    </span>
  );
};

export default DottedSeparator;
